import styled from "@emotion/styled";
import Congrat from "@components/icons/Congrat";
import Prompt from "@components/icons/ Prompt";
import Claim from "@components/icons/Claim";
import Complain from "@components/icons/Complain";
import Request from "@components/icons/Request";

export const Container = styled.div`
  max-width: 14em;
  border-radius: 5%;
  overflow: hidden;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  cursor: pointer;
`;

export const Header = styled.div`
  background-color: ${({ bg }: { bg: string }) => bg};
  color: white;
  font-family: Poppins Ligth;
  font-size: 1.5em;
  text-align: center;
  padding: 1vh 0;
`;
export const CongratIcon = styled(Congrat)`
  width: 30%;
  display: block;
  margin: 2.5vh auto;
`;
export const PromptIcon = styled(Prompt)`
  width: 30%;
  display: block;
  margin: 2.5vh auto;
`;
export const ClaimIcon = styled(Claim)`
  width: 30%;
  display: block;
  margin: 2.5vh auto;
`;
export const ComplainIcon = styled(Complain)`
  width: 30%;
  display: block;
  margin: 2.5vh auto;
`;
export const RequestIcon = styled(Request)`
  width: 30%;
  display: block;
  margin: 2.5vh auto;
`;

export const IconContainer = styled.div``;
export const Detail = styled.div`
  font-family: Poppins Ligth;
  font-size: 0.9em;
  margin-bottom: 13%;
  margin-left: 4%;
  margin-right: 4%;
  text-align: center;
`;
